import React from 'react';
import { Link } from 'react-router-dom';

export function MarriageGuide() {

    return (
        <section id="SchoolGuide">
            <div className="container-fluid mt-3 guide">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div>
                                <p className="pageTitle text-center">Guide to Submit Request for Marriage Records</p>
                            </div>

                            <div className="card mt-4 overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex flex-row justify-content-md-start justify-content-md-between flex-md-nowrap flex-wrap">
                                    <div className="order-1 pe-3 guide-number">
                                        <img src="./images/01Guide/1.png" alt="" />
                                    </div>
                                    <div className="guide-title order-md-2 order-3 px-md-3">
                                        Request for Marriage Records
                                    </div>
                                    <div className="order-md-4 order-2 ps-3 guide-icon flex-grow-1 align-self-md-start align-self-end text-end">
                                        <img src="./images/01Guide/Marriage/01.png" alt="" />
                                    </div>
                                    <div className="flex-grow-1 order-md-3 order-4" >
                                        <p className="m-0 px-md-3">
                                            Go to <a href="https://www.nas.gov.sg/erequest/">https://www.nas.gov.sg/erequest/</a>, click "Submit Request" tab, and select "Marriage Records". NAS can only search for marriage records from the Registry of Marriages dated on and before 15 September 1961.
                                            <br />For Muslim marriages, please visit <a href="https://www.marriage.gov.sg/muslim/marriage-records/search-marriage-records" target="_blank" rel="noopener noreferrer"><b><u>here</u></b></a>.
                                            <br />For civil marriages dated on and after 16 September 1961, please visit <a href="https://www.marriage.gov.sg/civil/marriage-records/search-marriage-records" target="_blank" rel="noopener noreferrer"><b><u>here</u></b></a>.
                                        </p>
                                    </div>

                                </div>
                            </div>

                            <div className="card mt-3 overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex flex-row justify-content-md-start justify-content-md-between flex-md-nowrap flex-wrap">
                                    <div className="order-1 pe-3 guide-number">
                                        <img src="./images/01Guide/2.png" alt="" />
                                    </div>
                                    <div className="guide-title order-md-2 order-3 px-md-3">
                                        Submit Request Form
                                    </div>
                                    <div className="order-md-4 order-2 ps-3 guide-icon flex-grow-1 align-self-md-start align-self-end text-end">
                                        <img src="./images/01Guide/Marriage/02.png" alt="" />
                                    </div>
                                    <div className="flex-grow-1 order-md-3 order-4" >
                                        <p className="m-0 px-md-3">
                                            Input your contact details and the particulars of the couple. Please provide as much information as possible to help us conduct the search (eg. aliases, date of marriage, etc)
                                        </p>
                                    </div>

                                </div>
                            </div>

                            <div className="card mt-3 overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex flex-row justify-content-md-start justify-content-md-between flex-md-nowrap flex-wrap">
                                    <div className="order-1 pe-3 guide-number">
                                        <img src="./images/01Guide/3.png" alt="" />
                                    </div>
                                    <div className="guide-title order-md-2 order-3 px-md-3">
                                        Payment
                                    </div>
                                    <div className="order-md-4 order-2 ps-3 guide-icon flex-grow-1 align-self-md-start align-self-end text-end">
                                        <img src="./images/01Guide/content/05and06.png" alt="" />
                                    </div>
                                    <div className="flex-grow-1 order-md-3 order-4" >
                                        <p className="m-0 px-md-3">
                                            There will be a non-refundable Request Administration Fee of ${parseFloat(process.env.REACT_APP_ADMINFEE)} (inclusive of {parseInt(process.env.REACT_APP_GST)}% GST) regardless of the outcome of the search. <br />If a specific date of marriage is given, we will provide the findings within 3 working days.
                                            <br />For each specified year, we will take up to 7 working days per year.
                                        </p>
                                    </div>

                                </div>
                            </div>

                            <div className="card mt-3 overflow-hidden">
                                <div className="card-header"></div>
                                <div className="card-body d-flex flex-row justify-content-md-start justify-content-md-between flex-md-nowrap flex-wrap">
                                    <div className="order-1 pe-3 guide-number">
                                        <img src="./images/01Guide/4.png" alt="" />
                                    </div>
                                    <div className="guide-title order-md-2 order-3 px-md-3">
                                        Delivery / Collection
                                    </div>
                                    <div className="order-md-4 order-2 ps-3 guide-icon flex-grow-1 align-self-md-start align-self-end text-end">
                                        <img src="./images/01Guide/Marriage/05.png" alt="" />
                                    </div>
                                    <div className="flex-grow-1 order-md-3 order-4" >
                                        <p className="m-0 px-md-3">
                                            NAS will issue a letter updating you on the results of the search. If the record is found, a certified extract copy of the marriage record will be provided.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="guide_button mt-3">
                                <Link to={'/marriage/disclaimer'} className="btn btn-primary theme-bg-color me-2">Request for search</Link>
                                <Link to={'/'} className="btn btn-secondary me-2">Back</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}





